import { leaveManageApiKeyStore } from "../../api/leave-manage-api-key-store";
import { SiTrackGrid } from "../../components/si-track-grid/si-track-grid";
import { UserPermissionName } from "../../models/user-permission-name";
import { requestColumns } from "./columns/request-grid-columns";

interface LeaveRequestsComponent {
    onEditLeave: (data: any) => void;
}
export const LeaveRequestsComponent = ({ onEditLeave }: LeaveRequestsComponent) => {
    return (
        <SiTrackGrid
            fileTitle='leave_request'
            dataItemKey="leaveID"
            columns={requestColumns}
            queryConfig={leaveManageApiKeyStore.getLeaves()}
            onEdit={onEditLeave}
            actionPermissions={{
                edit: UserPermissionName.EDIT_LEAVE,
                export: UserPermissionName.DOWNLOAD_GRID
            }}
        />
    );
}